import { axlesFrom, railsFrom } from "./axles";
function AxleBeams({
  wheels,
  skeleton,
  finish
}) {
  const beams = axlesFrom(wheels);
  let rails = [];
  switch (skeleton) {
    case "axles":
      rails = [];
      break;
    case "frame":
      rails = railsFrom(beams);
      break;
    default: {
      const _exhaustive = skeleton;
      return _exhaustive;
    }
  }
  return <group>
      {beams.map((beam) => <mesh key={`axle-${beam.axle}`} position={[beam.x, beam.y, 0]}>
          <boxGeometry args={[beam.section, beam.section, beam.halfSpan * 2]} />
          <meshPhysicalMaterial {...finish} />
        </mesh>)}
      {rails.map((rail) => <mesh key={`rail-${rail.z}`} position={[rail.x, rail.y, rail.z]}>
          <boxGeometry args={[Math.max(rail.length, rail.section), rail.section, rail.section]} />
          <meshPhysicalMaterial {...finish} />
        </mesh>)}
    </group>;
}
export {
  AxleBeams
};
